module.exports = __webpack_public_path__ + "static/fiscal-726b2a7ea6e5278d2458a8d3d696f351.png";